import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'kangarootime-ui';
import { Mutation } from 'react-apollo';
import { GET_CHANNELS } from '../../../../graphql/queries';
import { LEAVE_CHANNEL } from '../../../../graphql/mutations';

const LeaveChannelButton = ({
  channelId,
  onClick,
  ...props
}) => {
  const handleChannelLeave = (cache, { data: { leaveChannel } }) => {
    // read current channels data from the cache
    let { getChannels } = cache.readQuery({ query: GET_CHANNELS });
    const { channel: channelToRemove } = leaveChannel;

    // remove the channel from cache
    getChannels = getChannels.filter(channel => channel.id !== channelToRemove.id);
    cache.writeQuery({
      query: GET_CHANNELS,
      data: {
        getChannels
      }
    });
  };

  return (
    <Mutation
      mutation={LEAVE_CHANNEL}
      update={handleChannelLeave}
    >
      {(leavelChannel) => (
        <Button
          type='danger'
          onClick={() => {
            onClick({
              title: 'Leave Channel',
              message: 'Are you sure you want to leave this channel?',
              affirmativeChoice: 'Yes',
              negativeChoice: 'Cancel',
              affirmativeCallback: () => leavelChannel({
                variables: {
                  channelId
                }
              })
            });
          }}
        >Leave Channel</Button>
      )}
    </Mutation>
  );
};

LeaveChannelButton.propTypes = {
  channelId: PropTypes.string,
  onClick: PropTypes.func
};

export default LeaveChannelButton;
